import React from "react";
import { Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Collapsible from "react-collapsible";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronLeft,
} from "@fortawesome/fontawesome-free-solid";

export default function TabSection({
  children,
  title = null,
  description = null,
  topDivider = false,
  bottomDivider = false,
  card = true,
  collapsible = true,
  openbydefault = false,
}) {
  const body = collapsible ? (
    <Row>
      <Col>
        {topDivider ? <hr className="bold-default-hr" /> : null}
        <Collapsible
          open={openbydefault}
          trigger={
            <Card.Title>
              {title}
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{ float: "right" }}
              />
              <Row>
                <Col className="small mt-3">{description}</Col>
              </Row>
            </Card.Title>
          }
          triggerWhenOpen={
            <Card.Title>
              {title}
              <FontAwesomeIcon
                icon={faChevronDown}
                style={{ float: "right" }}
              />
            </Card.Title>
          }
        >
          {children}
        </Collapsible>
        {bottomDivider ? <hr className="bold-default-hr" /> : null}
      </Col>
    </Row>
  ) : (
    <Row>
      <Col>
        {topDivider ? <hr className="bold-default-hr" /> : null}
        <h5>{title}</h5>
        <p style={{ color: "red", marginBottom: "20px", marginTop: "20px" }}>
          {description}
        </p>
        {children}
        {bottomDivider ? <hr className="bold-default-hr" /> : null}
      </Col>
    </Row>
  );

  return card ? (
    <Card className="mb-4">
      <Card.Body>{body}</Card.Body>
    </Card>
  ) : (
    body
  );
}
